import { createContext } from "react";

export const WithdrawModalsContext = createContext();
